import React, { useState, useEffect } from "react";
import { useInfiniteQuery } from "react-query";
import { ItemCard } from "./index.js";
import "./Content.scss";

const fetchQuery = async (searchType, searchTerm, pageParam) => {
	const options = {
		method: "GET",
	};
	const response = await fetch(
		`https://api.jikan.moe/v4/${searchType}?q=${searchTerm}&page=${pageParam}&limit=12&sfw=true`,
		options
	);
	const res = response.json();

	return res;
};

const Content = () => {
	const [searchTerm, setSearchTerm] = useState("");
	const [searchType, setSearchType] = useState("");
	const [term, setTerm] = useState("");
	const [type, setType] = useState("anime");
	const [lastPage, setLastPage] = useState(false);

	const { data, status, fetchNextPage, isFetchingNextPage } =
		useInfiniteQuery(
			["results", searchType, searchTerm],
			({ pageParam = 1 }) =>
				fetchQuery(searchType, searchTerm, pageParam),
			{
				staleTime: Infinity,
				refetchOnWindowFocus: false,
				retry: 2,
				enabled: !!searchTerm && !!searchType,
				getNextPageParam: (last_page = data.pages[0], allPages) => {
					console.log(last_page);
					if (last_page.pagination.last_visible_page === allPages) {
						return undefined;
					} else return allPages.length + 1;
				},
			}
		);

	useEffect(() => {
		if (
			status === "success" &&
			data?.pages[0].pagination.last_visible_page ===
				data?.pageParams.length
		)
			setLastPage(true);
	}, [data, setLastPage, status]);

	console.log(data);

	const handleSubmit = (e) => {
		e.preventDefault();
		setSearchTerm(term);
		setSearchType(type);
	};

	return (
		<div className="container">
			<form onSubmit={handleSubmit}>
				<div className="search_bar">
					<div class="input">
						<input
							placeholder="Search for an anime or manga.."
							value={term}
							onChange={(e) => setTerm(e.target.value)}
						/>
						<button
							class="icon_button"
							disabled={term.length < 2}
							onMouseUp={() => {
								setTerm("");
							}}
						>
							{term.length > 0 && <p>X</p>}
						</button>
					</div>
					<select
						value={type}
						onChange={(e) => setType(e.target.value)}
					>
						<option value="anime">Anime</option>
						<option value="manga">Manga</option>
					</select>

					<button
						class="button"
						type="submit"
						disabled={term.length < 2}
					>
						Search
					</button>
				</div>
			</form>

			<div className="container">
				{status === "loading" ? (
					<div id="loading"></div>
				) : data?.pages[0].data.length === 0 && status !== "idle" ? (
					<div className="error">
						<span>&#9888;</span>
						<h2>Results not found.</h2>
						<p>Please try another search.</p>
					</div>
				) : (
					status === "success" &&
					data.pages?.length > 0 && (
						<>
							{data?.pages.map((page) =>
								page?.data.map((item, index) => (
									<ItemCard
										key={index}
										item={item}
										type={searchType}
									/>
								))
							)}

							<button
								className="load_more"
								onClick={() => fetchNextPage()}
								disabled={lastPage || isFetchingNextPage}
							>
								{isFetchingNextPage
									? "Loading more..."
									: !lastPage
									? "Load More"
									: "Nothing more to load"}
							</button>
						</>
					)
				)}
			</div>
		</div>
	);
};

export default Content;
